import { CheckboxTreeNode } from '@emi/shared/models';
import { createAction, props } from '@ngrx/store';

export const getSelectedCheckBoxes = createAction('[Checkboxes] Get selected checkboxes');

export const updateCheckboxes = createAction('[Checkboxes] Update checkboxes', props<{ checkbox: CheckboxTreeNode }>());

export const setCheckboxes = createAction('[Checkboxes] Set all checkboxes', props<{ checkboxes: CheckboxTreeNode[] }>());

export const clearCheckboxes = createAction('[Checkboxes] Clear checkboxes');
